<template>
  <Flex direction="column">
    <BaseCard gray>
      <Flex direction="column">
        <LogoDescription />
        <ImageUpload />
      </Flex>
    </BaseCard>
    <BaseCard gray>
      <Flex direction="column">
        <BaseInput
          v-model="formData.invoiceHeader"
          type="textarea"
          :info="$t('admin.invoices.content.header_description')"
          :label="$t('admin.invoices.content.header_title')"
          v-test="'invoiceHeader'"
        />
        <BaseInput
          v-model="formData.invoiceRecipientTemplate"
          type="textarea"
          :label="$t('admin.invoices.content.customer_information_title')"
          v-test="'invoiceRecipientTemplate'"
        />
        <BaseInput
          v-model="formData.invoiceFooter"
          type="textarea"
          :label="$t('admin.invoices.content.footer_title')"
          v-test="'invoiceFooter'"
        />
        <BaseInput
          v-if="formData.settings.sales.thermalSupport"
          v-model="formData.invoiceFooterThermal"
          type="textarea"
          :label="$t('admin.invoices.content.footer_thermal_title')"
          v-test="'invoiceFooterThermal'"
        />
        <BaseText @click="showVariablesModal = true">
          {{ $t('admin.invoices.content.help_link') }}
        </BaseText>
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import type { Ref } from 'vue';
import { inject } from 'vue';
import ImageUpload from './ImageUpload.vue';
import LogoDescription from './LogoDescription.vue';
import type { InvoiceFormData } from './useInvoices';

const formData = inject<InvoiceFormData>('formData')!;
const showVariablesModal = inject<Ref<boolean>>('showVariablesModal')!;
</script>
